import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../application/services/auth.service';

// Envía withCredentials (cookies HttpOnly) en todas las requests.
// En rutas protegidas también adjunta el CSRF token.
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  let cloned = req.clone({ withCredentials: true });

  if (!req.url.includes('/public/')) {
    const csrf = authService.getCsrfToken();
    if (csrf) {
      cloned = cloned.clone({ setHeaders: { 'X-Csrf-Token': csrf } });
    }
  }

  return next(cloned);
};
